'use client';

import { useState } from 'react';
import { postWaitlist } from '@/lib/api';
import { track } from '@/lib/events';

interface SessionEndBannerProps {
  onClose: () => void;
}

export function SessionEndBanner({ onClose }: SessionEndBannerProps) {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!email) return;
    try {
      await postWaitlist(email);
    } catch { /* silent */ }
    setDone(true);
    track('waitlist_signup', { reason: 'session-end' });
  }

  return (
    <div
      className="fixed bottom-16 left-1/2 -translate-x-1/2 z-40 w-full max-w-lg px-4"
      style={{ animation: 'fade-up 0.4s ease forwards' }}
    >
      <div className="bg-surface-container border border-outline-variant px-5 py-4 flex items-center gap-4 shadow-2xl">
        <div className="flex-1 min-w-0">
          {done ? (
            <p className="font-mono text-[11px] tracking-widest text-primary">
              &#9679; LOGGED — WE&apos;LL BE IN TOUCH
            </p>
          ) : (
            <>
              <p className="text-sm text-on-surface mb-2.5 font-medium">Hope that was useful.</p>
              <form onSubmit={submit} className="flex gap-2">
                <input
                  type="email"
                  required
                  placeholder="your@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 min-w-0 bg-surface border border-outline-variant px-3 py-1.5 text-xs font-mono text-on-surface placeholder:text-outline focus:border-primary-bright focus:outline-none transition-colors"
                />
                <button
                  type="submit"
                  className="bg-primary-bright text-on-primary font-mono text-[10px] font-bold tracking-widest px-4 py-1.5 hover:bg-primary active:scale-95 transition-all shrink-0"
                >
                  STAY UPDATED
                </button>
              </form>
            </>
          )}
        </div>
        <button
          onClick={onClose}
          className="text-outline hover:text-on-surface-variant transition-colors shrink-0 text-lg leading-none"
        >
          &#x2715;
        </button>
      </div>
    </div>
  );
}
